import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopCompHardware = dynamic(() => import('../../components/electronics/computer-hardware/DesktopComputerHardware'), {
  loading: () => <Loading />,

});
const MobileCompHardware = dynamic(() => import('../../components/electronics/computer-hardware/MobileComputerHardware'), {
  loading: () => <Loading />,

});
const electronicsShowroom = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Computer Hardware Store Billing Software & POS Solutions</title>
        <link rel="canonical" href="https://queuebuster.co/electronics/computer-hardware-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/electronics/computer-hardware-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Optimize your computer hardware store with cutting-edge billing software and efficient POS solutions. Streamline transactions & manage daily stock effortlessly." />
        <meta property="og:title" content="Computer Hardware Store Billing Software & POS Solutions | QueueBuster Android POS" />
        <meta property="og:description" content="Optimize your computer hardware store with cutting-edge billing software and efficient POS solutions. Streamline transactions, manage inventory, and enhance customer service seamlessly with QueueBuster POS." />
        <meta property="og:url" content="https://queuebuster.co/electronics/computer-hardware-pos-billing-software" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/computer-hardware.jpg" />
      </Head>
         <SchemaTags page="computer-hardware-pos-billing-software" />
      {mobileView ? <MobileCompHardware /> : <DesktopCompHardware />}
    </>
  )
}
export default electronicsShowroom